import { render, staticRenderFns } from "./MenuBarLanguage.vue?vue&type=template&id=65ec9238&"
import script from "./MenuBarLanguage.vue?vue&type=script&lang=js&"
export * from "./MenuBarLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports